import * as React from 'react';
import './TextEditor.css'
import { stripHtml } from '../helper';
import htmlToDraft from 'html-to-draftjs';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
class TextEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            editorState: EditorState.createEmpty(),
            update: true
        };
    }

    componentWillUpdate(prevProps) {
        if ((prevProps.value !== this.props.value && (this.props.type === 'sport' || this.props.type === 'email' || this.props.type === 'notification' || this.props.type === 'events')) && this.state.update && this.props.edit) {
            this.setState({
                editorState: EditorState.createWithContent(
                    ContentState.createFromBlockArray(
                        htmlToDraft(prevProps.value || '').contentBlocks,
                    ),
                ),
                update: false,
            })
        }
    }

    onChange = (value) => {
        this.setState({ value });
        if (this.props.onChange) {
            this.props.onChange(
                value.toString('html')
            );
        }
        if (this.props.pendingValue) {
            const currentContent = stripHtml(this.props.value);
            const currentContentLength = currentContent.length;
            this.props.pendingValue(160 - currentContentLength);
        }
    };
    onEditorStateChange = (editorState) => {
        this.setState({ editorState });
        if (this.props.onChange) {
            this.props.onChange(
                draftToHtml(convertToRaw(editorState.getCurrentContent())).toString('html')
            );
        }
    };

    render() {
        let classes = {
            wrapperClassName: 'editor-wrapper',
            editorClassName: 'editor',
        };
        if (this.props.fullwidth) {
            classes = {
                wrapperClassName: 'editor-wrapper full',
                editorClassName: 'editor full',
            };
        }
        const { editorState } = this.state;
        return (
                <Editor
                    editorState={editorState}
                    wrapperClassName={classes.wrapperClassName}
                    editorClassName={classes.editorClassName}
                    onEditorStateChange={this.onEditorStateChange}
                />
        );
    }
}

export default TextEditor;